import Base from './Base';
import Swiper from 'swiper/swiper-bundle.min';
import 'swiper/swiper-bundle.min.css';
import { evt, utils, store } from '@/core';

const { qs, qsa } = utils;
const { dom, bounds } = store;

import { scrollAnim } from '@/components';
export default class extends Base {
  onEnter() {
    super.onEnter();
    console.log('entra')
  }

  onLeave() {
    super.onLeave();
  }

  onEnterCompleted() {
    super.onEnterCompleted();
    //Swiper Home
    const swiperHome = qs(".home-swiper")
    
    if( swiperHome && swiperHome.classList.contains('stopped') ) {      
      swiperHome &&
      new Swiper(swiperHome, {
        spaceBetween:0,
        loop: true,
        allowTouchMove: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
      });
    }else{
      swiperHome &&
      new Swiper(swiperHome, {
        spaceBetween:0,
        loop: true,
        allowTouchMove: false,
        autoplay: {
          delay: 6500,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
      });

    }

    
  }

  onLeaveCompleted() {
    super.onLeaveCompleted();
  }

}
